import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import configureStore from './store/store';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import history from './utils/history';
import config from './utils/config';
import * as Sentry from '@sentry/react';
import 'bootstrap/scss/bootstrap.scss';
import './index.scss';
import ErrorFallback from './components/errorFallback';

const store = configureStore();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    environment: window.location.hostname.includes('qa-') ? 'dev' : 'prod',
  });
}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={ErrorFallback}>
    <Router history={history}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);
